/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_ButtonInputs */

const vi_grower_area_qr_button = /** @type {(inputs: Grower_Area_Qr_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR vùng trồng`)
};

/**

* @param {Grower_Area_Qr_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_button = /** @type {((inputs?: Grower_Area_Qr_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_button(inputs)
});